export const setServiceAlertPopupVisible = (payload) => ({
  type: "SET_SERVICE_ALERT_POPUP_VISIBLE",
  payload,
});

export const setServiceAlertModalDate = (payload) => ({
  type: "SET_SERVICE_ALERT_MODAL_DATE",
  payload,
});

export const initServiceAlert = (payload) => ({
  type: "INIT_SERVICE_ALERT",
  payload,
}); 